import React from "react"
import { useToggle } from "#/utils/Hooks"
import { useHistory } from "react-router"
import { useIntl } from "react-intl"
import { NavItemWrapper } from "./MainNavigation"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { AppLockedDownModal, LockedDownModalType } from "./nav-modals/AppLockedDownModal"
import { Paths } from "#/utils/Paths"
import { GatedIcon } from "@carrotfertility/carotene-core"
import { useBookingActionTracking } from "#/services/memberActionTracking/BookingTrackingProvider"

export function ProviderFinderNavItem({ onClick }: { onClick?: () => void }): JSX.Element {
  const [isAppLockedDownModalOpen, toggleAppLockedDownModal] = useToggle(false)
  const history = useHistory()
  const intl = useIntl()
  const { isInAppLockdown } = useCurrentUser()
  const { endBookingFlow } = useBookingActionTracking()

  const onNavigateToProviderFinder = () => {
    if (isInAppLockdown) {
      toggleAppLockedDownModal()
    } else {
      // Main navigation starts a new search; the booking flow's own return controls preserve it.
      endBookingFlow?.()
      history.push(Paths.PROVIDER_FINDER)
      onClick()
    }
  }

  return (
    <>
      <NavItemWrapper
        onClick={onNavigateToProviderFinder}
        link={Paths.PROVIDER_FINDER}
        button
        text={intl.formatMessage({ defaultMessage: "Find care and services" })}
        extraNavIndicator={isInAppLockdown ? <GatedIcon color="primary" fontSize="small" /> : null}
      />

      {isAppLockedDownModalOpen && (
        <AppLockedDownModal
          onClose={toggleAppLockedDownModal}
          open={isAppLockedDownModalOpen}
          modalType={LockedDownModalType.ProviderFinder}
        />
      )}
    </>
  )
}
